var RegistrationContentComponent = /** @class */ (function () {
    function RegistrationContentComponent() {
    }
    return RegistrationContentComponent;
}());
export { RegistrationContentComponent };
